var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{class:_vm.stateClass,attrs:{"options":_vm.options,"placeholder":_vm.$t('formCsvDelimiterPlaceholder'),"deselect-label":"","allow-empty":false,"loading":_vm.isLoading},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }